import { PageBannerDTO } from '../../models/dto/page-banner';

export class PageBannerGroupDTO extends PageBannerDTO {
    groupId: number;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.groupId = attributes['groupId'] || null;

    }

}
